import { Lexer } from '../types'
import { eatChar } from './eat-char'

export function eatNewline(lexer: Lexer): string {
  const value = eatChar(lexer)

  lexer.line++

  lexer.col = 0

  return value
}
